import React, { useState, useEffect } from 'react';
import Autosuggest from 'react-autosuggest';

const AutocompleteLocations = ({ input, label, meta: { touched, error, warning } }) => {
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (input.value) {
      // input.value is just the location ID, we need to fetch the location name
      // For now, just keep the field empty until user selects
      setValue('');
    }
  }, [input.value]);

  const onChange = (event, { newValue }) => {
    setValue(newValue);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    // Only pass the location ID to the form field
    input.onChange(suggestion._id);
    setValue(suggestion.what.title.value);
  };

  const clearInput = () => {
    input.onChange({});
    setValue('');
  };

  const onSuggestionsFetchRequested = async ({ value }) => {
    if (!value || value.length === 0) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await fetch('/api/locations/all', {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem('token')
        }
      });
      const data = await response.json();
      const locationsList = data.items || data.results || [];

      // Filter locations based on search value
      const filtered = locationsList.filter(location =>
        location.what.title.value.toLowerCase().includes(value.toLowerCase())
      );

      setSuggestions(filtered);
    } catch (err) {
      console.error('Error fetching locations:', err);
      setSuggestions([]);
    }
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const getSuggestionValue = suggestion => suggestion.what.title.value;

  const renderSuggestion = suggestion => (
    <div>
      <strong>{suggestion.what.title.value}</strong>
      {suggestion.what.shortdescription?.value && (
        <div style={{ fontSize: '0.85em', color: '#666' }}>
          {suggestion.what.shortdescription.value}
        </div>
      )}
    </div>
  );

  const inputProps = {
    placeholder: "Zoek een locatie...",
    value,
    onChange
  };

  return (
    <div>
      <label>{label}</label>
      <div className="inputs">
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          className="form-control"
          onSuggestionSelected={onSuggestionSelected}
          inputProps={inputProps}
        />
        <span
          onClick={clearInput}
          id="searchclear"
          className="usericonbox glyphicon glyphicon-remove-circle"
          style={{ cursor: 'pointer' }}
        ></span>
      </div>
      {error && <span className="text-danger" style={{ fontSize: '0.85em' }}>{error}</span>}
      {touched && !error && value && (
        <span className="text-success" style={{ fontSize: '0.85em' }}>
          ✓ Locatie geselecteerd
        </span>
      )}
    </div>
  );
};

export default AutocompleteLocations;
